/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { property } from 'lit/decorators.js';
import { MgtBaseProvider } from '@microsoft/mgt-element';
import { Providers } from '@microsoft/mgt-element';
import { MockProvider } from '@microsoft/mgt-element';
import { customElement } from '@microsoft/mgt-element';
/**
 * Sets global provider to a mock Provider
 *
 * @export
 * @class MgtMockProvider
 * @extends {LitElement}
 */
let MgtMockProvider = class MgtMockProvider extends MgtBaseProvider {
    /**
     * method called to initialize the provider. Each derived class should provide
     * their own implementation
     *
     * @protected
     * @memberof MgtBaseProvider
     */
    initializeProvider() {
        Providers.globalProvider = new MockProvider(!this.signedOut);
    }
};
__decorate([
    property({
        attribute: 'signed-out',
        type: Boolean
    }),
    __metadata("design:type", Object)
], MgtMockProvider.prototype, "signedOut", void 0);
MgtMockProvider = __decorate([
    customElement('mock-provider')
], MgtMockProvider);
export { MgtMockProvider };
